export const DISTANCE_FROM_TARGET = 20

export const MODAL_HEIGHT = 200

export const getBaseModalCss = (shouldModalOpenUp: boolean) => `
  position: absolute;
  border: 4px solid #7f52ff;
  border-radius: 10px;
  min-width: 300px;
  max-width: 350px;
  width: auto;
  height: ${MODAL_HEIGHT}px;
  z-index: 9999;
  background: linear-gradient(130deg, #4781bb 0%, #61bfbc 100%);
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxOCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMEwxNy42NjAzIDE1TDAuMzM5NzQ2IDE1TDkgMFoiIGZpbGw9IiM3RjUyRkYiLz4KPC9zdmc+Cg==");
    ${
      shouldModalOpenUp
        ? `bottom: -18px;
       transform: rotate(60deg);
      `
        : `
       top: -15px;
      `
    }
    
    left: 50%;
    position: absolute;
  }
`

export const fadeInAnimationVariants = {
  initial: {
    opacity: 0,
    scale: 0.75,
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      ease: 'easeOut',
      duration: 0.15,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.75,
    transition: {
      ease: 'easeIn',
      duration: 0.15,
    },
  },
}
